import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPortalUserInfoState {
  profile: IPortalUserInfoData | null;
  loading: boolean;
  error: string | null;
  lastFetchedAt: string | null;
}

const name = "portalUserInfo";

export const portalUserInfoInitialState: IPortalUserInfoState = {
  profile: null,
  loading: false,
  error: null,
  lastFetchedAt: null,
};

export const portalUserInfoSlice = createSlice({
  name,
  initialState: portalUserInfoInitialState,
  reducers: {
    setPortalUserInfoLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setPortalUserInfo(state, action: PayloadAction<IPortalUserInfoData>) {
      state.profile = action.payload;
      state.error = null;
      state.lastFetchedAt = new Date().toISOString();
    },
    setPortalUserInfoError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    clearPortalUserInfo() {
      return portalUserInfoInitialState;
    },
  },
});

export const {
  setPortalUserInfoLoading,
  setPortalUserInfo,
  setPortalUserInfoError,
  clearPortalUserInfo,
} = portalUserInfoSlice.actions;

export default portalUserInfoSlice.reducer;
